import {
  Box,
  Circle,
  Flex,
  Grid,
  Heading,
  HStack,
  Text,
  useColorModeValue,
  Accordion,
  AccordionButton,
  AccordionIcon,
  AccordionItem,
  AccordionPanel,
  VStack,
  Input,
  Button,
  IconButton,
  useToast,
} from "@chakra-ui/react";
import React, { useEffect, useState } from "react";
import SelectCompanyLogo from "../Components/SelectCompanyLogo";
import MyInput from "../../../../../components/formComponents/MyInput";
import SelectInput from "../../../../../components/formComponents/SelectInput";
import MySelect from "../../../../../components/formComponents/MySelect";
import MultiImageUpload from "../Components/MultiImageUpload";
import UploadFileStyleTwo from "../Components/UploadFileStyleTwo";
import FloorMapUpload from "../Components/FloorMapUpload";
import ThreeDPanel from "../Components/ThreeDPanel";
import { Icon } from "@iconify/react/dist/iconify.js";
import ColorPicker from "../../../../../components/formComponents/ColorPicker";
import {
  checkImageOrientation,
  getAxiosConfig,
  getImageUrls,
  getTopColorsFromMultipleUrls,
} from "../../../../../utils/helpers";
import { useNavigate, useOutletContext } from "react-router-dom";
import axios from "axios";
import PrimaryButton from "../../../../../components/PrimaryButton";
import { useFormContext } from "../FormStateContext";
import { MAX_COMPANY_NAME_LENGTH } from "../../../../../utils/constant";
import PopupWrapper from "../../../../../components/PopupWrapper";
import TestViewButton from "../../../../../components/TestViewButton";
import ViewLayoutBtn from "../../../../../components/ViewLayoutBtn";
import DeleteIcon from "../../../../../components/DeleteIcon";
import { toast } from "react-toastify";
import {
  DndContext,
  closestCenter,
  KeyboardSensor,
  PointerSensor,
  useSensor,
  useSensors,
} from "@dnd-kit/core";
import {
  arrayMove,
  SortableContext,
  sortableKeyboardCoordinates,
  verticalListSortingStrategy,
  useSortable,
} from "@dnd-kit/sortable";
import { CSS } from "@dnd-kit/utilities";

function SortableItem({ id, children }) {
  const {
    attributes,
    listeners,
    setNodeRef,
    transform,
    transition,
    isDragging,
  } = useSortable({ id });

  const style = {
    transform: CSS.Transform.toString(transform),
    transition,
    opacity: isDragging ? 0.5 : 1,
    position: "relative",
  };

  return (
    <div ref={setNodeRef} style={style}>
      <div
        {...attributes}
        {...listeners}
        className="absolute right-16 top-[10px] z-[2] cursor-grab flex items-center gap-1 bg-teal-50 hover:bg-teal-100 text-teal-700 px-2 py-1 rounded-md border border-teal-200 text-xs font-medium select-none shadow-sm transition-all active:cursor-grabbing"
      >
        <Icon icon="icon-park-outline:drag" className="w-3.5 h-3.5" />
        <span>Reorder</span>
      </div>
      {children}
    </div>
  );
}

const areaOptions = [
  { label: "Area 1", value: "area1" },
  { label: "Area 2", value: "area2" },
  { label: "Area 3", value: "area3" },
];

const colors = [
  "#81634B",
  "#81634B",
  "#81634B",
  "#81634B",
  "#81634B",
  "#81634B",
  "#81634B",
  "#81634B",
];

function RenderLayout({
  isEdit,
  data,
  setActiveTab,
  isRandom,
  handlePublicLink,
  storeActiveTab,
}) {
  const area = {
    area: "",
    colorPalette: [],
    areaImage: [],
    keyPlan: {},
    isPotrait: false,
    selectedKeyPlanIdx: null,
    selection1: {},
    selection2: {},
    selection3: {},
    selection4: {},
  };

  const initialValues = {
    companyLogo: [],
    companyName: "",
    layouts: [
      {
        floorMap: null,
        selection1: {},
        selection2: {},
        selection3: {},
        selection4: {},
        legend: [{ key: "", value: "" }],
      },
    ],
    areas: [{ ...area }],
  };
  const { setData, FORMDATA } = useFormContext();
  const [formData, setFormData] = useState(() => {
    const baseValues = FORMDATA ? FORMDATA : { ...initialValues };
    const areasWithId = (baseValues.areas || []).map((area, idx) => ({
      ...area,
      dragId:
        area.dragId ||
        area._id ||
        `area-${Date.now()}-${idx}-${Math.random().toString(36).substr(2, 5)}`,
    }));
    return { ...baseValues, areas: areasWithId };
  });
  const { projectData, basicInfo } = useOutletContext() || {
    projectData: {},
    basicInfo: {},
  };
  const [submitLoad, setSubmitLoad] = useState(false);

  const [accControl, setAccControl] = useState([0]);

  const sensors = useSensors(
    useSensor(PointerSensor, {
      activationConstraint: {
        distance: 8,
      },
    }),
  );

  function handleDragEnd(event) {
    const { active, over } = event;
    if (active && over && active.id !== over.id) {
      setFormData((prev) => {
        const oldIndex = prev.areas.findIndex(
          (item) => item.dragId === active.id,
        );
        const newIndex = prev.areas.findIndex(
          (item) => item.dragId === over.id,
        );

        const newAreas = arrayMove(prev.areas, oldIndex, newIndex);

        setAccControl((prevAcc) => {
          return prevAcc.map((idx) => {
            if (idx === oldIndex) return newIndex;
            if (oldIndex < newIndex) {
              if (idx > oldIndex && idx <= newIndex) return idx - 1;
            } else {
              if (idx >= newIndex && idx < oldIndex) return idx + 1;
            }
            return idx;
          });
        });

        return {
          ...prev,
          areas: newAreas,
        };
      });
    }
  }
  const nav = useNavigate();
  console.log("FORM DATA", formData, FORMDATA);
  // useEffect(()=> {
  //   setFormData((p)=> ({...p, areas: p.areas.map((a)=> ({...a, keyPlan: ""}))}))
  // },[formData.floorMap])
  const validateForm = () => {
    const errors = [];

    // Company Name validation
    if (!formData.companyName || formData.companyName.trim() === "") {
      errors.push("Company Name is required");
    }
    if (formData.companyName.length > MAX_COMPANY_NAME_LENGTH) {
      errors.push(
        `Company Name should be less than ${MAX_COMPANY_NAME_LENGTH} characters`,
      );
    }

    // Company Logo validation
    if (!formData.companyLogo || formData.companyLogo.length === 0) {
      errors.push("Company Logo is required");
    }

    // Floor Map validation
    // if (!formData.floorMap || formData.floorMap.length === 0) {
    //   errors.push("Floor Map is required");
    // }

    // Areas validation
    if (!formData.areas || formData.areas.length === 0) {
      errors.push("At least one area is required");
    } else {
      formData.areas.forEach((area, index) => {
        // Area name validation
        if (!area.area || area.area.trim() === "") {
          errors.push(`Area ${index + 1}: Area name is required`);
        }

        // Color palette validation
        // if (!area.colorPalette || area.colorPalette.length === 0) {
        //   errors.push(`Area ${index + 1}: Color palette is required`);
        // }

        // Area image validation
        if (!area.areaImage || area.areaImage.length === 0) {
          errors.push(`Area ${index + 1}: 3D Image is required`);
        }

        // Key plan validation
        // if (!area.keyPlan || Object.keys(area.keyPlan).length === 0) {
        //   errors.push(`Area ${index + 1}: Key plan selection is required`);
        // }
      });
    }

    return errors;
  };

  async function handleSubmit() {
    // Show loading toast

    try {
      setSubmitLoad(true);
      // Validation function

      // Run validation
      const validationErrors = validateForm();

      if (validationErrors.length > 0) {
        // Show only the first validation error
        toast.error(validationErrors[0]);
        throw new Error(validationErrors[0]);
        // Focus on the first invalid field
        // Stop execution if validation fails
      }

      const finalFormData = new FormData();
      console.log("FORM DATA", formData);

      // Add company name
      finalFormData.append("companyName", formData.companyName || "");

      // Add companyLogo
      if (formData.companyLogo && formData.companyLogo.length > 0) {
        finalFormData.append("companyLogo", formData.companyLogo?.[0]);
      }

      // Extract floorMaps array from layouts
      const floorMaps = (formData.layouts || []).map(
        (layout) => layout.floorMap,
      );
      floorMaps.forEach((floorMap, idx) => {
        if (floorMap) {
          finalFormData.append(`floorMap_${idx}`, floorMap);
        }
      });

      // Create layouts array without floorMap key
      const layoutsWithoutFloorMap = (formData.layouts || []).map((layout) => ({
        selection1: layout.selection1 || {},
        selection2: layout.selection2 || {},
        selection3: layout.selection3 || {},
        selection4: layout.selection4 || {},
        legend: layout.legend || [],
        ...(layout.floorMap instanceof Blob || layout.floorMap instanceof File
          ? {}
          : { floorMap: layout.floorMap }),
      }));
      finalFormData.append("layouts", JSON.stringify(layoutsWithoutFloorMap));

      // Add areaData
      if (formData.areas && Array.isArray(formData.areas)) {
        formData.areas.forEach((area, index) => {
          if (
            area.areaImage &&
            area.areaImage.length > 0 &&
            (area?.areaImage?.[0] instanceof File ||
              area?.areaImage?.[0] instanceof Blob)
          ) {
            finalFormData.append(`images_${index}`, area.areaImage?.[0]);
          }
        });
      }
      let Areas = formData.areas.map((a) => {
        let areaImage = a.areaImage?.[0] || null;
        if (
          areaImage &&
          (areaImage instanceof File || areaImage instanceof Blob)
        ) {
          return { ...a, areaImage: [] };
        } else {
          return { ...a };
        }
      });
      finalFormData.append("areas", JSON.stringify(Areas));
      finalFormData.append(
        "projectId",
        isRandom ? "6826fe28f13d9ed89b2a732c" : projectData?._id || "",
      );
      isRandom && finalFormData.append("type", "internal");

      console.log("Final Form Data", finalFormData);

      // Send the request
      let Data = {};
      if (isEdit) {
        const { data } = await axios.put(
          `${process.env.REACT_APP_BACK_URL}/api/presentation/add-rendered/${isEdit}`,
          finalFormData,
          getAxiosConfig({}, true),
        );
        toast.success("Render layout submitted successfully.");

        handlePublicLink(
          `render/${data?.data?._id}/${
            isRandom ? data?.data?.companyName : projectData?.title
          }`,
        );
        Data = data;
      } else {
        const { data } = await axios.post(
          `${process.env.REACT_APP_BACK_URL}/api/presentation/add-rendered`,
          finalFormData,
          getAxiosConfig({}, true),
        );
        Data = data;
        toast.success("Render layout submitted successfully.");

        handlePublicLink(
          `render/${data?.data?._id}/${
            isRandom ? data?.data?.companyName : projectData?.title
          }`,
        );
      }
      // Close loading toast
      // toast.close(loadingToast);

      // Show success toast

      setActiveTab();
      // Reset form or redirect as needed
      // setFormData(initialValues);

      return Data;
    } catch (error) {
      console.log(error.message, "Error in submitting form");

      // Show error toast
      toast.error("Failed to submit the form. Please try again.");
    } finally {
      setSubmitLoad(false);
    }
  }

  useEffect(() => {
    if (FORMDATA) {
      // setFormData(FORMDATA);
      return;
    }
    if (isEdit) {
      console.log(
        "IS EDIT RENDER",
        data.filter((v) => v._id == isEdit),
      );
      // return;
      const found = data.filter((v) => v._id == isEdit)?.[0];
      if (found) {
        setFormData({
          ...found,
          areas: (found.areas || []).map((area, idx) => ({
            ...area,
            dragId:
              area.dragId ||
              area._id ||
              `area-edit-${Date.now()}-${idx}-${Math.random().toString(36).substr(2, 5)}`,
          })),
        });
      }
    }
  }, [isEdit]);
  useEffect(() => {
    if (FORMDATA) {
      // setFormData(FORMDATA);
      return;
    }
    !isRandom &&
      setFormData((p) => ({
        ...p,
        companyLogo: basicInfo?.companyLogo || [],
        companyName: basicInfo?.companyName || "",
        layouts: basicInfo?.layouts || [
          {
            floorMap: basicInfo?.floorMap || null,
            selection1:
              typeof basicInfo?.selection1 == "string"
                ? JSON.parse(basicInfo?.selection1)
                : basicInfo?.selection1 || {},
            selection2:
              typeof basicInfo?.selection2 == "string"
                ? JSON.parse(basicInfo?.selection2)
                : basicInfo?.selection2 || {},
            selection3:
              typeof basicInfo?.selection3 == "string"
                ? JSON.parse(basicInfo?.selection3)
                : basicInfo?.selection3 || {},
            selection4:
              typeof basicInfo?.selection4 == "string"
                ? JSON.parse(basicInfo?.selection4)
                : basicInfo?.selection4 || {},
            legend: basicInfo?.legend || [],
          },
        ],
      }));
  }, [basicInfo]);

  useEffect(() => {
    setFormData((p) => ({
      ...p,
      layouts: (p.layouts || []).map((layout) => ({
        ...layout,
        selection1:
          typeof layout?.selection1 == "string"
            ? JSON.parse(layout?.selection1)
            : layout?.selection1,
        selection2:
          typeof layout?.selection2 == "string"
            ? JSON.parse(layout?.selection2)
            : layout?.selection2,
        selection3:
          typeof layout?.selection3 == "string"
            ? JSON.parse(layout?.selection3)
            : layout?.selection3,
        selection4:
          typeof layout?.selection4 == "string"
            ? JSON.parse(layout?.selection4)
            : layout?.selection4,
      })),
    }));
  }, [JSON.stringify(formData)]);

  const handleAddArea = () => {
    setFormData((prev) => ({
      ...prev,
      areas: [
        ...prev.areas,
        {
          ...area,
          dragId: `area-new-${Date.now()}-${Math.random().toString(36).substr(2, 5)}`,
        },
      ],
    }));
    setAccControl([formData.areas.length]);
  };

  const handleAddAreaBelow = (targetIdx) => {
    const newArea = {
      ...area,
      dragId: `area-new-${Date.now()}-${Math.random().toString(36).substr(2, 5)}`,
    };

    setFormData((prev) => {
      const updatedAreas = [...prev.areas];
      updatedAreas.splice(targetIdx + 1, 0, newArea);
      return {
        ...prev,
        areas: updatedAreas,
      };
    });
    setAccControl([targetIdx + 1]);
  };

  return (
    <Box>
      <Box display={"flex"} flexDir={"column"} width={"100%"}>
        <div
          // flex={1}
          // gap={7}
          // display={"flex"}
          // flexDirection={"column"}
          // // borderRight={"1px solid #eee"}
          // p={4}
          className="grid grid-cols-2 p-4 flex-1 "
        >
          <SelectCompanyLogo
            setImage={(image) => {
              setFormData((prev) => ({ ...prev, companyLogo: [image] }));
            }}
            isViewOnly={!isRandom}
            image={formData.companyLogo?.[0]}
          />
          <MyInput
            required={true}
            readOnly={!isRandom}
            placeholder={"Type here Company Name"}
            label={"Company Name"}
            value={formData.companyName}
            error={
              formData.companyName?.length > MAX_COMPANY_NAME_LENGTH
                ? `Company name should be less than ${MAX_COMPANY_NAME_LENGTH} characters`
                : ""
            }
            onChange={(e) =>
              setFormData((prev) => ({ ...prev, companyName: e.target.value }))
            }
          />
        </div>
        <Box flex={1} p={4} bgColor={"#fafafa"} rounded={"xl"} shadow={"sm"}>
          <div className="flex items-center justify-between">
            <h2 className="text-center text-xl text-teal-600">Floor Map</h2>
          </div>

          {/* Multiple Layouts Display */}
          {(formData.layouts || []).map((layout, layoutIdx) => (
            <div
              key={layoutIdx}
              className="mt-8 p-6 bg-white border-2 border-teal-200 rounded-lg"
            >
              <div className="flex items-center justify-between mb-6">
                <h3 className="text-lg font-semibold text-teal-700">
                  Layout {layoutIdx + 1}
                </h3>
                {formData.layouts.length > 1 && (
                  <button
                    onClick={() => {
                      const layoutIndexToDelete = layoutIdx;
                      setFormData((prev) => {
                        const newLayouts = (prev.layouts || []).filter(
                          (_, i) => i !== layoutIndexToDelete,
                        );

                        // Update areas: clear selectedKeyPlanIdx if it referenced deleted layout,
                        // and shift indices > deleted index left by 1
                        const updatedAreas = (prev.areas || []).map((a) => {
                          const idx = a?.selectedKeyPlanIdx;
                          if (idx === layoutIndexToDelete) {
                            return {
                              ...a,
                              selectedKeyPlanIdx: null,
                              keyPlan: {},
                            };
                          }
                          if (
                            typeof idx === "number" &&
                            idx > layoutIndexToDelete
                          ) {
                            return { ...a, selectedKeyPlanIdx: idx - 1 };
                          }
                          return a;
                        });

                        return {
                          ...prev,
                          layouts: newLayouts,
                          areas: updatedAreas,
                        };
                      });
                    }}
                    className="flex items-center gap-2 px-2 py-1 bg-red-500 hover:bg-red-600 text-white rounded-lg transition-colors"
                  >
                    <Icon icon="mdi:delete" width="20" height="20" />
                    Delete
                  </button>
                )}
              </div>

              <div className="grid grid-cols-2 gap-4">
                {/* Floor Map Upload */}
                <div>
                  <Box>
                    <h4 className="text-sm font-medium text-gray-700 mb-2">
                      Floor Map
                    </h4>
                    <UploadFileStyleTwo
                      label={""}
                      isViewOnly={false}
                      key={`floormap-${layoutIdx}`}
                      multiple={false}
                      file={layout?.floorMap || []}
                      setFile={(val) => {
                        setFormData((v) => {
                          const updatedLayouts = [...(v.layouts || [])];
                          updatedLayouts[layoutIdx] = {
                            ...updatedLayouts[layoutIdx],
                            floorMap:
                              Array.isArray(val) && val?.length > 0
                                ? val?.[0]
                                : null,
                            selection1: {},
                            selection2: {},
                            selection3: {},
                            selection4: {},
                          };
                          // If floor map removed, clear any area references to this layout index
                          const updatedAreas = (v.areas || []).map((a) => {
                            if (
                              !val?.[0] &&
                              a?.selectedKeyPlanIdx === layoutIdx
                            ) {
                              return {
                                ...a,
                                selectedKeyPlanIdx: null,
                                keyPlan: {},
                              };
                            }
                            return a;
                          });

                          return {
                            ...v,
                            layouts: updatedLayouts,
                            areas: updatedAreas,
                          };
                        });
                      }}
                    />
                  </Box>

                  {/* Selection 1, 2, 3 and 4 */}
                  <Flex mt={2} justify={"space-between"} gap={2} wrap={"wrap"}>
                    <Box flex={1} minW={"45%"}>
                      <FloorMapUpload
                        floorMap={layout?.floorMap}
                        coordinates={layout?.selection1 || {}}
                        onSelectArea={(coordinates) => {
                          setFormData((v) => {
                            const updatedLayouts = [...(v.layouts || [])];
                            updatedLayouts[layoutIdx] = {
                              ...updatedLayouts[layoutIdx],
                              selection1: coordinates,
                            };
                            return { ...v, layouts: updatedLayouts };
                          });
                        }}
                        heading={"Select floor plan selection 1"}
                        isImageAreaSelection={true}
                      />
                    </Box>
                    <Box flex={1} minW={"45%"}>
                      <FloorMapUpload
                        floorMap={layout?.floorMap}
                        coordinates={layout?.selection2 || {}}
                        onSelectArea={(coordinates) => {
                          setFormData((v) => {
                            const updatedLayouts = [...(v.layouts || [])];
                            updatedLayouts[layoutIdx] = {
                              ...updatedLayouts[layoutIdx],
                              selection2: coordinates,
                            };
                            return { ...v, layouts: updatedLayouts };
                          });
                        }}
                        heading={"Select floor plan selection 2"}
                        isImageAreaSelection={true}
                      />
                    </Box>
                    <Box flex={1} minW={"45%"}>
                      <FloorMapUpload
                        floorMap={layout?.floorMap}
                        coordinates={layout?.selection3 || {}}
                        onSelectArea={(coordinates) => {
                          setFormData((v) => {
                            const updatedLayouts = [...(v.layouts || [])];
                            updatedLayouts[layoutIdx] = {
                              ...updatedLayouts[layoutIdx],
                              selection3: coordinates,
                            };
                            return { ...v, layouts: updatedLayouts };
                          });
                        }}
                        heading={"Select floor plan selection 3"}
                        isImageAreaSelection={true}
                      />
                    </Box>
                    <Box flex={1} minW={"45%"}>
                      <FloorMapUpload
                        floorMap={layout?.floorMap}
                        coordinates={layout?.selection4 || {}}
                        onSelectArea={(coordinates) => {
                          setFormData((v) => {
                            const updatedLayouts = [...(v.layouts || [])];
                            updatedLayouts[layoutIdx] = {
                              ...updatedLayouts[layoutIdx],
                              selection4: coordinates,
                            };
                            return { ...v, layouts: updatedLayouts };
                          });
                        }}
                        heading={"Select floor plan selection 4"}
                        isImageAreaSelection={true}
                      />
                    </Box>
                  </Flex>
                </div>

                {/* Legend Section */}
                <div className="w-full p-4 bg-gray-50 rounded-lg border border-gray-200">
                  <div className="flex items-center justify-between mb-4">
                    <h4 className="text-lg font-semibold text-gray-800">
                      Legend
                    </h4>
                    <button
                      onClick={() => {
                        setFormData((prev) => {
                          const updatedLayouts = [...(prev.layouts || [])];
                          updatedLayouts[layoutIdx] = {
                            ...updatedLayouts[layoutIdx],
                            legend: [
                              ...(updatedLayouts[layoutIdx].legend || []),
                              { key: "", value: "" },
                            ],
                          };
                          return { ...prev, layouts: updatedLayouts };
                        });
                      }}
                      className="flex items-center gap-2 px-3 py-1 bg-teal-500 hover:bg-teal-600 text-white rounded-lg transition-colors"
                    >
                      <Icon icon="mdi:plus" width="20" height="20" />
                      Add
                    </button>
                  </div>
                  <div className="space-y-3">
                    {(layout?.legend || []).map((item, legendIdx) => (
                      <div key={legendIdx} className="flex gap-3 items-end">
                        <div className="flex-1">
                          <label className="block text-sm font-medium text-gray-700 mb-1">
                            Key
                          </label>
                          <input
                            type="text"
                            placeholder="Enter key"
                            value={item.key || ""}
                            onChange={(e) => {
                              setFormData((prev) => {
                                const updatedLayouts = [
                                  ...(prev.layouts || []),
                                ];
                                const updatedLegend = [
                                  ...(updatedLayouts[layoutIdx].legend || []),
                                ];
                                updatedLegend[legendIdx] = {
                                  ...updatedLegend[legendIdx],
                                  key: e.target.value,
                                };
                                updatedLayouts[layoutIdx] = {
                                  ...updatedLayouts[layoutIdx],
                                  legend: updatedLegend,
                                };
                                return { ...prev, layouts: updatedLayouts };
                              });
                            }}
                            className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-teal-500"
                          />
                        </div>
                        <div className="flex-1">
                          <label className="block text-sm font-medium text-gray-700 mb-1">
                            Value
                          </label>
                          <input
                            type="text"
                            placeholder="Enter value"
                            value={item.value || ""}
                            onChange={(e) => {
                              setFormData((prev) => {
                                const updatedLayouts = [
                                  ...(prev.layouts || []),
                                ];
                                const updatedLegend = [
                                  ...(updatedLayouts[layoutIdx].legend || []),
                                ];
                                updatedLegend[legendIdx] = {
                                  ...updatedLegend[legendIdx],
                                  value: e.target.value,
                                };
                                updatedLayouts[layoutIdx] = {
                                  ...updatedLayouts[layoutIdx],
                                  legend: updatedLegend,
                                };
                                return { ...prev, layouts: updatedLayouts };
                              });
                            }}
                            className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-teal-500"
                          />
                        </div>
                        <button
                          onClick={() => {
                            setFormData((prev) => {
                              const updatedLayouts = [...(prev.layouts || [])];
                              updatedLayouts[layoutIdx] = {
                                ...updatedLayouts[layoutIdx],
                                legend: (
                                  updatedLayouts[layoutIdx].legend || []
                                ).filter((_, i) => i !== legendIdx),
                              };
                              return { ...prev, layouts: updatedLayouts };
                            });
                          }}
                          className="px-3 py-2 text-red-500 hover:text-red-700 hover:bg-red-50 rounded-lg transition-colors"
                        >
                          <Icon icon="mdi:delete" width="20" height="20" />
                        </button>
                      </div>
                    ))}
                  </div>
                </div>
              </div>
              <ViewLayoutBtn
                floorMap={
                  Array.isArray(layout?.floorMap)
                    ? layout?.floorMap?.[0]
                    : layout?.floorMap
                }
                selection1={layout?.selection1}
                selection2={layout?.selection2}
                width={1400}
                layout={layout}
                index={layoutIdx + 1}
              />
            </div>
          ))}

          {/* Add Layout Button */}
          <div className="w-full p-4 mt-6 flex justify-center gap-4">
            <Button
              onClick={() => {
                setFormData((prev) => ({
                  ...prev,
                  layouts: [
                    ...(prev.layouts || []),
                    {
                      floorMap: null,
                      selection1: {},
                      selection2: {},
                      selection3: {},
                      selection4: {},
                      legend: [{ key: "", value: "" }],
                    },
                  ],
                }));
              }}
              colorScheme="teal"
            >
              <Icon icon="mdi:plus" width="24" height="24" />
              Add New Layout
            </Button>
          </div>
        </Box>
      </Box>
      <Accordion
        my={5}
        defaultIndex={[0]}
        allowMultiple
        index={accControl}
        onChange={(exp) => {
          setAccControl(exp);
        }}
      >
        <div className="bg-[#fafafa] p-4 rounded-xl ">
          <div className="relative flex items-center justify-center mb-4">
            <h2 className="text-center text-xl font-semibold text-teal-600">
              Areas
            </h2>
            <Button
              size="sm"
              colorScheme="teal"
              variant="outline"
              className="!absolute right-0"
              onClick={handleAddArea}
            >
              + Add Area
            </Button>
          </div>

          <DndContext
            sensors={sensors}
            collisionDetection={closestCenter}
            onDragEnd={handleDragEnd}
          >
            <SortableContext
              items={formData.areas.map((val) => val.dragId)}
              strategy={verticalListSortingStrategy}
            >
              {formData.areas.map((area, idx) => (
                <SortableItem key={area.dragId} id={area.dragId}>
                  <AreaLayout
                    idx={idx}
                    area={area}
                    formData={formData}
                    setFormData={setFormData}
                    handleAddArea={() => handleAddAreaBelow(idx)}
                  />
                </SortableItem>
              ))}
            </SortableContext>
          </DndContext>
        </div>
      </Accordion>
      <div className="py-2 sticky bottom-0 bg-white z-10 grid grid-cols-2 gap-4">
        <TestViewButton data={formData} type={"render"} />
        <Button
          colorScheme={"teal"}
          w={"100%"}
          disabled={submitLoad}
          isLoading={submitLoad}
          loadingText="Submitting"
          onClick={handleSubmit}
        >
          Submit
        </Button>
      </div>
    </Box>
  );
}

const AreaLayout = ({ idx, area, formData, setFormData, handleAddArea }) => {
  const [isPreview, setIsPreview] = useState(false);
  return (
    <AccordionItem shadow={"md"} my={4}>
      <h2>
        <AccordionButton>
          <Box
            as="span"
            flex="1"
            textAlign="left"
            display={"flex"}
            justifyContent={"space-between"}
            alignItems={"center"}
            shadow={"sm"}
          >
            Area Plan {idx + 1}{" "}
            {formData.areas[idx]?.area ? `(${formData.areas[idx].area})` : ""}
            {idx > 0 && (
              <DeleteIcon
                onClick={(e) => {
                  e.stopPropagation();
                  setFormData((prev) => ({
                    ...prev,
                    areas: prev.areas.filter((_, i) => idx !== i),
                  }));
                }}
              />
            )}
          </Box>
          <AccordionIcon />
        </AccordionButton>
      </h2>
      <AccordionPanel pb={4}>
        <Box
          display={"flex"}
          justifyContent={"space-between"}
          alignItems={"center"}
          width={"100%"}
          gap={10}
        >
          <Box
            display={"flex"}
            bgColor={"#FAFAFA"}
            flexDirection={"column"}
            gap={4}
            padding={3}
            rounded={"md"}
            flex={1}
            // flexBasis={"50%"}
          >
            <MyInput
              label={"Area "}
              placeholder={"Select Area"}
              options={areaOptions}
              onChange={(e) => {
                const updatedAreas = [...formData.areas];
                updatedAreas[idx].area = e.target.value;
                setFormData((prev) => ({ ...prev, areas: updatedAreas }));
              }}
              value={formData.areas[idx].area}
              required={true}
            />

            {/* <ColorPicker
                    label={"Choose Color Palette"}
                    colors={area.colorPalette}
                    setColors={(colors) => {
                      console.log(colors, "colors in color picker");
                      const updatedAreas = [...formData.areas];
                      updatedAreas[idx].colorPalette = colors;
                      setFormData((prev) => ({ ...prev, areas: updatedAreas }));
                    }}
                  /> */}

            <Flex justify={"space-between"} gap={4} alignItems={"end"}>
              <Box flexBasis={"50%"}>
                <UploadFileStyleTwo
                  label={"Upload 3D Image"}
                  setFile={async (file) => {
                    const updatedAreas = [...formData.areas];
                    // console.log(file, "file in area image");
                    updatedAreas[idx].areaImage = [...file];
                    updatedAreas[idx].colorPalette =
                      file?.length > 0
                        ? await getTopColorsFromMultipleUrls(
                            getImageUrls(file),
                            5,
                          )
                        : [];
                    // console.log(updatedAreas[idx].colorPalette, "color palette");
                    if (
                      file?.[0] &&
                      (file?.[0] instanceof File || file?.[0] instanceof Blob)
                    ) {
                      checkImageOrientation(file?.[0])
                        .then((res) => {
                          updatedAreas[idx].isPotrait = res;
                          // console.log(res, "is potrait");
                          setFormData((prev) => ({
                            ...prev,
                            areas: updatedAreas,
                          }));
                        })
                        .catch((err) => {
                          console.error(
                            "Error checking image orientation:",
                            err,
                          );
                        });
                    } else {
                      updatedAreas[idx].isPotrait = false;

                      setFormData((prev) => ({
                        ...prev,
                        areas: updatedAreas,
                      }));
                    }
                  }}
                  file={area.areaImage}
                />
              </Box>
              <Box flexBasis={"50%"}>
                <FloorMapUpload
                  floorMap={
                    (formData.layouts || [])
                      .map((l) => l.floorMap)
                      .flat()
                      ?.filter(Boolean)?.[area?.selectedKeyPlanIdx] || null
                  }
                  isMultiple={true}
                  allFloorMaps={
                    (formData.layouts || [])
                      .map((l) => l.floorMap)
                      ?.flat()
                      .filter(Boolean) || []
                  }
                  selectedKeyPlanIdx={area?.selectedKeyPlanIdx}
                  onSelectArea={(coordinates, floorIdx) => {
                    const updatedAreas = [...formData.areas];
                    updatedAreas[idx].keyPlan = coordinates;
                    updatedAreas[idx].selectedKeyPlanIdx =
                      typeof floorIdx === "number" ? floorIdx : null;
                    setFormData((prev) => ({
                      ...prev,
                      areas: updatedAreas,
                    }));
                  }}
                  coordinates={area.keyPlan}
                  area={area}
                />
                {/* 
                    <UploadFileStyleTwo
                      label={"Select Key Plan"}
                      setFile={(file) => {
                        const updatedAreas = [...formData.areas];
                        updatedAreas[idx].areaImage = file;
                        setFormData((prev) => ({
                          ...prev,
                          areas: updatedAreas,
                        }));
                      }}
                      file={area.areaImage}
                      /> */}
              </Box>
            </Flex>
            {/* {area?.isPotrait && ( */}
            {area?.areaImage && area.areaImage?.[0] && (
              <Flex
                justifyContent={"space-between"}
                alignItems={"center"}
                gap={4}
                wrap={"wrap"}
              >
                <Box flexBasis={"48%"} bgColor={"white"}>
                  <FloorMapUpload
                    floorMap={area.areaImage?.[0]}
                    heading={"Select area image selection 1"}
                    btnText={"Select focus area"}
                    isLargeArea={true}
                    onSelectArea={(coordinates) => {
                      const updatedAreas = [...formData.areas];
                      updatedAreas[idx].selection1 = coordinates;
                      setFormData((prev) => ({
                        ...prev,
                        areas: updatedAreas,
                      }));
                    }}
                    coordinates={area?.selection1 || {}}
                    area={area}
                    isImageAreaSelection={true}
                  />
                </Box>
                <Box flexBasis={"48%"} bgColor={"white"}>
                  <FloorMapUpload
                    floorMap={area.areaImage?.[0]}
                    heading={"Select area image selection 2"}
                    btnText={"Select focus area"}
                    isLargeArea={true}
                    onSelectArea={(coordinates) => {
                      const updatedAreas = [...formData.areas];
                      updatedAreas[idx].selection2 = coordinates;
                      setFormData((prev) => ({
                        ...prev,
                        areas: updatedAreas,
                      }));
                    }}
                    coordinates={area?.selection2 || {}}
                    area={area}
                    isImageAreaSelection={true}
                  />
                </Box>
                <Box flexBasis={"48%"} bgColor={"white"}>
                  <FloorMapUpload
                    floorMap={area.areaImage?.[0]}
                    heading={"Select area image selection 3"}
                    btnText={"Select focus area"}
                    isLargeArea={true}
                    onSelectArea={(coordinates) => {
                      const updatedAreas = [...formData.areas];
                      updatedAreas[idx].selection3 = coordinates;
                      setFormData((prev) => ({
                        ...prev,
                        areas: updatedAreas,
                      }));
                    }}
                    coordinates={area?.selection3 || {}}
                    area={area}
                    isImageAreaSelection={true}
                  />
                </Box>
                <Box flexBasis={"48%"} bgColor={"white"}>
                  <FloorMapUpload
                    floorMap={area.areaImage?.[0]}
                    heading={"Select area image selection 4"}
                    btnText={"Select focus area"}
                    isLargeArea={true}
                    onSelectArea={(coordinates) => {
                      const updatedAreas = [...formData.areas];
                      updatedAreas[idx].selection4 = coordinates;
                      setFormData((prev) => ({
                        ...prev,
                        areas: updatedAreas,
                      }));
                    }}
                    coordinates={area?.selection4 || {}}
                    area={area}
                    isImageAreaSelection={true}
                  />
                </Box>
              </Flex>
            )}
            {/* )} */}
          </Box>

          {isPreview && (
            <PopupWrapper
              onClose={() => setIsPreview(false)}
              width={
                "max-w-[1400px] aspect-[1.77/1] max-h-[95svh] overflow-hidden full-space-box  h-auto"
              }
              maxHeight="h-full"
              isWidthAuto={true}
              padding={1}
              bgColor={"bg-white"}
              key={idx}
              aspectRatio={"1.77/1 !important"}
            >
              <div className="aspect-[1.77]">
                <ThreeDPanel
                  key={idx}
                  isPublicView={true}
                  details={formData.areas[idx]}
                  companyLogo={formData?.companyLogo?.[0]}
                  floorMap={
                    (formData.layouts || [])
                      .map((l) => l.floorMap)
                      .flat()
                      ?.filter(Boolean)?.[area?.selectedKeyPlanIdx] || null
                  }
                />
              </div>
            </PopupWrapper>
          )}
        </Box>

        <div className="grid grid-cols-2 gap-3 mt-2">
          <Button
            disabled={!area.area || area?.areaImage?.length == 0}
            onClick={() => setIsPreview(true)}
            colorScheme="teal"
            w={"100%"}
          >{`View Area ${idx + 1} Preview`}</Button>
          <Button
            w={"100%"}
            colorScheme="teal"
            variant={"outline"}
            onClick={handleAddArea}
          >
            + Add Area
          </Button>
        </div>
      </AccordionPanel>
    </AccordionItem>
  );
};

export default RenderLayout;
